<!--
 * @Description: 历史报警走势
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-22 09:17:45
 * @LastEditTime: 2022-12-30 15:02:50
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 历史报警走势 -->
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox">
        <echarts :chart-id="idName" :chart-option="options" v-if="isShow"></echarts>
        <img src="../../assets/img/bigScreen/noData.png" alt="" v-else>
        <!-- <el-empty :image="imgSrc" :image-size="80" v-else></el-empty> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
var dayjs = require('dayjs')
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isShow: true,
      imgSrc: require('../../assets/img/bigScreen/no-data.png'),
      options: {
        legend: {
          top: '5%',
          right: 'center'
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          top: '8%',
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: {
              color: '#02D9FD'
            },
            axisLine: {
              lineStyle: {
                color: '#0B3363'
              }
            },
            axisTick: { show: false }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#16263D'
              }
            },
          }
        ],
        color: ['#FF0000'],
        series: [
          {
            name: '',
            type: 'line',
            showSymbol: false,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#FF0000' },
                  { offset: 1, color: 'rgba(4,12,33,0)' }
                ],
                global: false
              }
            },
            smooth: true,
            data: []
          }
        ]
      },
      // timeArr: [],
      // countArr: []
    }
  },
  created() {
    // this.initStyle()
    // this.options.xAxis[0].data = this.timeArr
    // this.options.series[0].data = this.countArr
    this.getEchartsPolice()
  },
  computed: {
    idName() {
      return this.flag ? "echartsId6_big" : "echartsId6"
    },
      styleObj(){
      return this.flag ? {
          fontSize:20
      }:{
        fontSize:12
      }
    }
  },
  mounted() {},
  methods: {
 /*    init() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1 = echarts.init(document.getElementById(this.idName))
      // console.log(myChart1)
      // 绘制图表，this.echarts1_option是数据
      myChart1.setOption(this.options, true)
    }, */
    async getEchartsPolice() {
      let { code, msg, data } = await this.request.post(`/front/alarm/record/getAlarmCountStatisticsByDay?days=7`)
      let options = JSON.parse(JSON.stringify(this.options))
      if (code !== 200) {
        if(code==500){
          this.isShow = false
          return this.$message.error(msg)
        }
        return
      }
      if(data.length<1){
        // this.isShow = false
        // return
        let day1 = dayjs().format('YYYY-MM-DD')
        let day2 = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        let day3 = dayjs().subtract(2, 'day').format('YYYY-MM-DD')
        let day4 = dayjs().subtract(3, 'day').format('YYYY-MM-DD')
        let day5 = dayjs().subtract(4, 'day').format('YYYY-MM-DD')
        let day6 = dayjs().subtract(5, 'day').format('YYYY-MM-DD')
        let day7 = dayjs().subtract(6, 'day').format('YYYY-MM-DD')

        data = [
          { day: day1, alarmCount: 0 },
          { day: day2, alarmCount: 0 },
          { day: day3, alarmCount: 0 },
          { day: day4, alarmCount: 0 },
          { day: day5, alarmCount: 0 },
          { day: day6, alarmCount: 0 },
          { day: day7, alarmCount: 0 },
        ]
      }

      let xAxisData = []
      let seriesData = []
      xAxisData = data.map(({ day, alarmCount }) => {
        seriesData.push(alarmCount)
        return day.substr(5)
      })
      options.xAxis[0].data = xAxisData
      options.series[0].data = seriesData
      this.options = options
      // console.log(` this.countArr`,  this.countArr)
    },
     initStyle(){
      this.options.xAxis[0].axisLabel.fontSize = this.styleObj.fontSize
      this.options.yAxis[0].axisLabel.fontSize = this.styleObj.fontSize
      this.options.legend.textStyle.fontSize =this.styleObj.fontSize+2
    },
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        width: 100%;
        height: 100%;
        >img {
          width: 90%;
          height: 90%;
          margin-top: 5%;
        }
      }
    }
  }
}
</style>
